import { useState } from "react";
import axios from "axios";
import { UserX } from "lucide-react";
import { toast } from "sonner";
import { API } from "../App";

// Small "Block user" pill next to Report. Requires auth.
// Props:
//   targetUserId — the user_id to block (must not be self)
//   targetName   — display name for confirmation copy
//   token        — session token
//   onBlocked    — optional callback fired after successful block
const BlockUserButton = ({ targetUserId, targetName = "this user", token, onBlocked, iconOnly = false, className = "" }) => {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);

  const block = async () => {
    if (!token) { toast.error("Sign in to block a user"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/users/${targetUserId}/block`, { reason: "user_action" }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`Blocked ${targetName}. Their posts won't show in your feed.`);
      setConfirming(false);
      onBlocked?.(targetUserId);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not block user");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setConfirming(true); }}
        className={`text-[#8A92A0] hover:text-[#D14A85] transition-colors text-xs flex items-center gap-1 ${className}`}
        title="Block user"
        data-testid={`block-user-btn-${targetUserId}`}
      >
        <UserX className="w-3.5 h-3.5" />
        {!iconOnly && <span>Block</span>}
      </button>

      {confirming && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4" onClick={() => setConfirming(false)}>
          <div onClick={(e) => e.stopPropagation()} className="card max-w-sm w-full p-6" data-testid="block-user-modal">
            <h3 className="font-['Unbounded'] text-base font-bold text-white mb-2">Block {targetName}?</h3>
            <p className="text-sm text-[#8A92A0] mb-5">
              Their posts, comments and reposts will disappear from your feed. You can unblock them anytime from your Trust &amp; Safety settings.
            </p>
            <div className="flex gap-2 justify-end">
              <button onClick={() => setConfirming(false)} className="px-4 py-2 text-sm text-[#8A92A0] hover:text-white" data-testid="cancel-block-btn">Cancel</button>
              <button
                onClick={block}
                disabled={busy}
                className="px-4 py-2 rounded-lg bg-[#D14A85] text-white hover:bg-[#A04545] text-sm font-semibold disabled:opacity-60 flex items-center gap-2"
                data-testid="confirm-block-btn"
              >
                {busy ? "Blocking..." : "Block user"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BlockUserButton;
